import { useLingui } from '@lingui/react';
import IconShipping16 from '@warp-ds/icons/react/shipping-16';
import { Button } from '@warp-ds/react';
import { useRef, useState } from 'react';
import { t } from '../../../../../locales/texts';
import useInscreenObserver from '../../../../hooks/useInscreenObserver';
import usePulse from '../../../../hooks/usePulse';
import { useSidebarContext } from '../../../../state/SidebarContext';
import { SuggestShippingActionType, SuggestShippingType } from '../../../../types/uiTypes';
import ConfirmationModal from './ConfirmationModal';

type Props = {
    updateUiText: (uiResponse: SuggestShippingType) => void;
    uiText: SuggestShippingActionType;
    hasAskedForFiksFerdig?: boolean;
};

/**
 * This component renders the button "Be om Fiks ferdig" (suggest shipping),
 * to enble the buyer to suggest for the seller to use Fiks ferdig.
 */
const MakeSuggestion = ({ updateUiText, uiText }: Props) => {
    const { isOwnAd } = useSidebarContext();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showIsOwnAd, setShowIsOwnAd] = useState(false);
    const [isFirstClick, setIsFirstClick] = useState(true);
    const { i18n } = useLingui();

    const sectionRef = useRef<HTMLDivElement>(null);
    const { trackViewSuggestShipping, trackExpandSuggestShipping } = usePulse();

    // Runs the tracking event when user has crolled into the div with the reference
    useInscreenObserver(sectionRef, trackViewSuggestShipping, {
        threshold: 0.9,
        once: true,
    });

    const handleConfirm = (uiResponse: SuggestShippingType) => {
        setIsModalOpen(false);
        /** Give the modal time to close properly before being unmounted */
        setTimeout(() => {
            updateUiText(uiResponse);
        }, 10);
    };

    const openModalHandler = () => {
        if (isOwnAd) {
            setShowIsOwnAd(true);
        } else {
            setIsModalOpen(true);
            if (isFirstClick) {
                trackExpandSuggestShipping();
                setIsFirstClick(false);
            }
        }
    };

    return (
        <div ref={sectionRef}>
            <Button
                className="w-full max-w-full! flex items-center space-x-4"
                onClick={openModalHandler}
            >
                <IconShipping16 />
                <span>{uiText.text}</span>
            </Button>
            {showIsOwnAd && (
                <p
                    className="s-text-negative text-center my-4 text-xs"
                    data-testid="validation-cannot-buy-own-item"
                >
                    {i18n._(t.payment.errorMessage)}
                </p>
            )}

            <ConfirmationModal
                isOpen={isModalOpen}
                close={() => setIsModalOpen(false)}
                uiText={uiText.confirmation}
                handleConfirm={handleConfirm}
            />
        </div>
    );
};

export default MakeSuggestion;
